import ContactPage from '@/Components/HomePage/ContactPage'
import ArchitectureSection from '@/Components/Revinue/ArchitectureSection'
import AutomationSection from '@/Components/Revinue/AutomationSection'
import FAQSection, { faqs } from '@/Components/Revinue/FAQSection'
import ProductSeo from '@/Components/seo/ProductSeo'
import { PRODUCTS } from '@/lib/products'

import Landing from '@/Components/Revinue/Landing'

import TestimonialSection from '@/Components/Revinue/TestimonialSection'

export default function Revinu() {
    return (
        <>
            {/* Title, description, OG tags and schema all come from lib/products.js via ProductSeo */}
            <ProductSeo product={PRODUCTS.revinu} faqs={faqs} />
            <Landing />
            <AutomationSection />
            <ArchitectureSection />
            <TestimonialSection />

            <section className='m-auto bg-slate-300/50'>
                <ContactPage />
            </section>
            <FAQSection />
        </>
    )
}
